import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import compose from 'recompose/compose';
import withPropsOnChange from 'recompose/withPropsOnChange';
import moment from 'moment-timezone';
import withTimezone from '../../auth/utils/withTimezone';
import MonthSwitcher from './components/MonthSwitcher';

export default compose(
  withTimezone,
  withState('month', 'setMonth', props => moment.tz(props.timezone).startOf('month').toJSON()),
  withHandlers({
    next: props => () => props.setMonth(moment.tz(props.month, props.timezone).add(1, 'month').toJSON()),
    prev: props => () => props.setMonth(moment.tz(props.month, props.timezone).subtract(1, 'month').toJSON()),
  }),
  withPropsOnChange(['month'], (props) => {
    if (props.onChange) {
      props.onChange(props.month);
    }
  })
)(MonthSwitcher);
